import React, { useState } from 'react';
import { X } from 'lucide-react';
import api from '../../lib/api';

const INITIAL = { reason: '', business_benefit: '', hours_saved: '', impact: '' };

export default function SuggestDeleteModal({ taskId, onClose, onSubmitted }) {
  const [form, setForm] = useState(INITIAL);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post('/rewards/deletion-suggestions', {
        task_id: taskId,
        reason: form.reason.trim(),
        business_benefit: form.business_benefit.trim() || null,
        hours_saved: form.hours_saved ? Number(form.hours_saved) : null,
        impact: form.impact.trim() || null,
      });
      onSubmitted?.();
      onClose();
    } catch (e) { alert(e.response?.data?.error || 'Failed to submit'); }
    finally { setBusy(false); }
  };

  return (
    <div className="tm-modal-overlay" style={{ zIndex: 10000 }} onClick={() => !busy && onClose()}>
      <div className="tm-modal" style={{ maxWidth: 480 }} onClick={(e) => e.stopPropagation()} data-testid="suggest-modal">
        <div className="flex items-start justify-between mb-3">
          <div>
            <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>Suggest task deletion</h3>
            <div style={{ fontSize: 12, color: 'var(--trello-text-muted)', marginTop: 2 }}>A Leader will review your suggestion. You earn points if approved.</div>
          </div>
          <button className="tm-btn-ghost" onClick={() => !busy && onClose()} data-testid="suggest-close"><X size={18} /></button>
        </div>
        <div className="space-y-3">
          <div>
            <div className="tm-label">Reason <span style={{ color: '#DE350B' }}>*</span></div>
            <textarea className="tm-input" rows={2} placeholder="Why should this task be deleted?"
              value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })}
              data-testid="suggest-reason" />
          </div>
          <div>
            <div className="tm-label">Business benefit</div>
            <textarea className="tm-input" rows={2} placeholder="How does deleting help the business?"
              value={form.business_benefit} onChange={(e) => setForm({ ...form, business_benefit: e.target.value })}
              data-testid="suggest-benefit" />
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div>
              <div className="tm-label">Hours saved</div>
              <input className="tm-input" type="number" step="0.5" min="0" placeholder="e.g. 4"
                value={form.hours_saved} onChange={(e) => setForm({ ...form, hours_saved: e.target.value })}
                data-testid="suggest-hours" />
            </div>
            <div>
              <div className="tm-label">Impact</div>
              <input className="tm-input" placeholder="e.g. low, redundant"
                value={form.impact} onChange={(e) => setForm({ ...form, impact: e.target.value })}
                data-testid="suggest-impact" />
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <button className="tm-btn-ghost" onClick={onClose} disabled={busy} data-testid="suggest-cancel">Cancel</button>
          <button className="tm-btn" style={{ background: '#DE350B' }} disabled={busy || !form.reason.trim()}
            onClick={submit} data-testid="suggest-submit">
            {busy ? 'Submitting…' : 'Submit suggestion'}
          </button>
        </div>
      </div>
    </div>
  );
}
